import { ComponentType } from 'react'

import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import { useFeaturesProvider } from 'modules/processes/components/ItemWizard/Providers/features'
import RequestContractData from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/ContractData/FillInformation'
import RequestBankAccountContent from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/RequestBankAccount/FillInformation'
import RequestAdditionalInformation from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/RequestEmployeeAdditionalInformation/FillInformation'
import RequestGeneralInformationContent from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/RequestGeneralInformation/FillInformation'
import RequestIdContent from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/RequestId/FillInformation'
import SendDocumentContent from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/SendDocument/FillInformation'
import SignDocumentsContent from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/SignDocuments/FillInformation'
import SingleTaskContent from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/Single/FillInformation'
import UploadDocumentContent from 'modules/processes/components/ItemWizard/Tasks/SuperTasks/UploadDocument/FillInformation'

export type TaskComponent = ComponentType

export const useFillInformationComponents = () => {
  const { featureAvailabilities } = useFeaturesProvider()

  const SUPER_TASKS: Partial<Record<TaskConfigurationTypes, TaskComponent>> = {
    [TaskConfigurationTypes.Single]: SingleTaskContent,
    [TaskConfigurationTypes.UploadDocument]: UploadDocumentContent,
    [TaskConfigurationTypes.SignDocuments]: featureAvailabilities.documents_templates?.available
      ? SendDocumentContent
      : SignDocumentsContent,
    [TaskConfigurationTypes.SendDocumentTemplate]: SendDocumentContent,
  }

  const DATA_COLLECTION_SUPER_TASKS: Partial<Record<DataCollectionCategories, TaskComponent>> = {
    [DataCollectionCategories.identificationNumber]: RequestIdContent,
    [DataCollectionCategories.bankInformation]: RequestBankAccountContent,
    [DataCollectionCategories.generalInformation]: RequestGeneralInformationContent,
    [DataCollectionCategories.employee_questions_cf]: RequestAdditionalInformation,
    [DataCollectionCategories.contract_data]: RequestContractData,
  }

  return Object.assign({}, SUPER_TASKS, DATA_COLLECTION_SUPER_TASKS)
}
